















































import { concatUrl } from '~/utils/string'

import CGoogleRating from '~/components/shared/configurable/rating/CGoogleRating.vue'
import DealersListItemVehicleButton from '~/components/car/dealers/map/list/item/ListItemVehicleButton'
import ListItemInfo from '~/components/car/dealers/map/list/item/ListItemInfo'

export default {
  components: {
    CGoogleRating,
    DealersListItemVehicleButton,
    ListItemInfo
  },
  props: {
    dealer: { type: Object, required: true },
    showAvatar: { type: Boolean, default: false }
  },
  computed: {
    dealerPageUrl() {
      return concatUrl(this.dealer.pageUrl, 'bl=1')
    }
  }
}
